import React from 'react';
import { Row, Label, FormGroup } from 'reactstrap';
import styles from '../FileClaim/Payment.module.css';
import classNames from 'classnames';
import { CreditCardInput } from '../../components/inputs/CreditCardInput';
import Cleave from 'cleave.js/react';
import ReactTooltip from 'react-tooltip';
import VisaIcon from '../../assets/images/cc-visa.svg';
import MasterCardIcon from '../../assets/images/cc-mastercard.svg';
import AmexIcon from '../../assets/images/cc-amex.svg';
import DiscoverIcon from '../../assets/images/cc-discover.svg';
import SecurityIcon from '../../assets/images/cc-security-code.svg';
import { ReactComponent as QuestionInfoIcon } from '../../assets/images/circle-questionmark.svg';



export default function PaymentInputs(props) {
    const { state, validator, handleInputChange, ccTypeChanged } = props;
    const ccValidation = state.clientId?.toLowerCase() === "njr" ? "required|card_num|invalid_card" : "required|card_num";
    return (<div>
        <FormGroup className={(state.errors.ccNumber || state.errors.ccInvalid) && state.validationFired ? "form-error inputContainer" : "inputContainer"}>
            <Label htmlFor="ccNumber" className="form-label">Credit Card Number</Label>
            <span aria-hidden="true" className="required-indicator">*</span>
            <div className={classNames("form-control", state.tokenExFocused ? styles.tokenExDivFocus : "")}>
                <div id="tokenEx-iframe-div" className={styles.tokenExIframeContainer}>                    
                </div>
                {/*<CreditCardInput*/}
                {/*    onCreditCardTypeChanged={ccTypeChanged}*/}
                {/*    handleInputChange={handleInputChange}*/}
                {/*    arialabelledby="ccNumber" autoComplete="cc-number"*/}
                {/*    ariarequired="true" className="form-control"*/}
                {/*    name="ccNumber" id="ccNumber"*/}
                {/*/>*/}
                <ul className={styles.ccImageList}>
                    {(state.ccType === "visa" || state.ccType === "unknown") &&
                        <li className="visa">
                            <span><img className={styles.ccImages} alt="Visa" src={VisaIcon} /></span>
                        </li>
                    }
                    {(state.ccType === "mastercard" || state.ccType === "unknown") &&
                        <li className="mastercard">
                            <span className=""><img className={styles.ccImages} alt="mastercard" src={MasterCardIcon} /></span>
                        </li>
                    }
                    {(state.clientId?.toLowerCase() !== "njr" && (state.ccType === "amex" || state.ccType === "unknown")) &&
                        <li className="amex">
                            <span className=""><img className={styles.ccImages} alt="Amex" src={AmexIcon} /></span>
                        </li>
                    }
                    {(state.ccType === "discover" || state.ccType === "unknown") &&
                        <li className="discover">
                            <span className="visuallyhidden"><img className={styles.ccImages} alt="Discover" src={DiscoverIcon} />
                            </span>
                        </li>
                    }
                </ul>
            </div>
            {state.errors.ccInvalid && <div className="errorMsg" aria-live="polite">The credit card number is invalid.</div>}
            {/*{validator.message("creditCardNumber", state.ccNumber, ccValidation)}*/}

        </FormGroup>
        <Row className="form-group twoColWrapper">
            <div className="col-6">
                <FormGroup className={(((state.errors.cardExpires || state.errors.ccExpired) && state.validationFired) ? "form-error" : "")}>
                    <Label htmlFor="cardExpires" className="form-label">Expiration Date</Label>
                    <span aria-hidden="true" className="required-indicator">*</span>
                    <Cleave
                        options={{ date: true, datePattern: ['m', 'y'] }}
                        aria-labelledby="cardExpires"
                        type="number"
                        autoComplete="cc-exp"
                        className="form-control"
                        type="text"
                        placeholder="MM/YY"
                        id="cardExpires"
                        name="cardExpires"
                        aria-required="true"
                        onChange={handleInputChange}
                        value={state.cardExpires}
                        onBlur={() => validator.showMessageFor('cardExpires')}
                    />
                    {state.errors.ccExpired && <div className="errorMsg" aria-live="polite">The credit card being used has expired.</div>}
                    {validator.message("expirationDate", state.cardExpires, "required|min:4", {
                        messages: {
                            min: "Expiration date is required."
                        }
                    })}
                </FormGroup>
            </div>
            <div className="col-6">
                <FormGroup className={((state.errors.securityCode || state.errors.securityCodeInvalid) && state.validationFired) ? "form-error" : ""}>
                    <Label htmlFor="securityCode" className="form-label">Security Code</Label>
                    <span aria-hidden="true" className="required-indicator">*</span>
                    <div className={styles.inputTooltip}>
                        <span className={styles.hasTooltip}>
                            <QuestionInfoIcon
                                data-tip data-for='tooltip'
                                aria-labelledby='tooltip'
                                aria-label='3 or 4 digits on the back of the card (front of American Express)'
                                role='tooltip'
                                className={styles.infoIcon}
                            />
                            <ReactTooltip
                                id='tooltip'
                                tabIndex="0"
                                clickable="true"
                                aria-haspopup='true'
                                className={styles.tooltiptext}
                                effect="solid"
                                type="light"
                                place={"bottom", "right"}
                                border={true}>
                                <img
                                    className={styles.ccPin}
                                    alt="Back of Card"
                                    src={SecurityIcon}
                                />
                                <br className="show-md-only" aria-hidden="true" />
                                3 or 4 digits on the back of the card (front of American Express)
                            </ReactTooltip>
                        </span>
                        <Cleave
                            options={{ numericOnly: true, blocks: [4] }}
                            autoComplete="cc-csc"
                            aria-labelledby="securityCode"
                            className="form-control"
                            aria-label="Security Code 3 or 4 digits on the back of the card (front of American Express)"
                            id="securityCode"
                            name="securityCode"
                            maxLength={4}
                            aria-required="true"
                            onChange={handleInputChange}
                            value={state.securityCode}
                            onBlur={() => validator.showMessageFor('securityCode')}
                        />
                    </div>
                    {validator.message("securityCode", state.securityCode, "required|cvv")}
                    {state.errors.securityCodeInvalid && <div className="errorMsg" aria-live="polite">The security code is invalid.</div>}
                </FormGroup>
            </div>
        </Row>
    </div>)
}